(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instinct-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('instinct-editorial')) {
 customElements.define('instinct-editorial', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   const dialog = this.querySelector('dialog');
   this.addEventListener('click', event => {
    const trigger = event.target.closest('[data-ide-photo]');
    if (trigger) {
     const img = new Image(); img.src = trigger.dataset.idePhoto; img.alt = trigger.dataset.ideTitle;
     dialog.querySelector('[data-ide-image]').replaceChildren(img);
     dialog.querySelector('[data-ide-heading]').textContent = trigger.dataset.ideTitle;
     dialog.querySelector('[data-ide-description]').textContent = trigger.dataset.ideDescription || '';
     const action = dialog.querySelector('[data-ide-action]');
     action.hidden = !trigger.dataset.ideLink;
     if (trigger.dataset.ideLink) { action.href = trigger.dataset.ideLink; action.textContent = trigger.dataset.ideCta + ' →'; }
     this.returnFocus = trigger; dialog.showModal();
    }
    if (event.target.closest('[data-ide-close]')) dialog.close();
   });
   dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
   dialog.addEventListener('close', () => { dialog.querySelector('[data-ide-image]').replaceChildren(); this.returnFocus?.focus({preventScroll:true}); });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instinct-header-v4"]) return;
  try {
    
if (!customElements.get('instinct-navigation')) {
 customElements.define('instinct-navigation',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const menu=this.querySelector('.idn-nav'),toggle=this.querySelector('[data-idn-menu]'),dialog=this.querySelector('dialog'),search=this.querySelector('[data-idn-search]');
   toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));menu.classList.toggle('is-open',open);});
   menu.addEventListener('click',event=>{if(event.target.closest('a')){menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');}});
   this.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.classList.contains('is-open')){menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');toggle.focus();}});
   search.addEventListener('click',()=>dialog.showModal());
   this.querySelector('[data-idn-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
   dialog.addEventListener('close',()=>search.focus());
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instinct-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('instinct-studio')) {
 customElements.define('instinct-studio', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.addEventListener('click', (event) => {
    const photo = event.target.closest('[data-ids-photo]');
    if (photo) {
     const dialog = this.querySelector('[data-ids-photo-dialog]');
     const image = new Image();
     image.src = photo.dataset.idsPhoto;
     image.alt = photo.dataset.idsTitle;
     dialog.querySelector('[data-ids-photo-title]').textContent = photo.dataset.idsTitle;
     dialog.querySelector('[data-ids-photo-content]').replaceChildren(image);
     this.returnFocus = photo;
     dialog.showModal();
    }
    const trigger = event.target.closest('[data-ids-open]');
    if (trigger) {
     const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.idsOpen));
     if (!dialog) return;
     this.returnFocus = trigger; dialog.showModal();
     dialog.querySelector('video')?.play().catch(() => {});
    }
    if (event.target.closest('[data-ids-close]')) event.target.closest('dialog').close();
   });
   this.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { dialog.querySelector('video')?.pause(); dialog.querySelector('[data-ids-photo-content]')?.replaceChildren(); this.returnFocus?.focus({preventScroll:true}); });
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instinct-signature-header"]) return;
  try {
    
if (!customElements.get('instinct-signature-navigation')) {
 customElements.define('instinct-signature-navigation',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const menu=this.querySelector('.idn-nav'),toggle=this.querySelector('[data-idn-menu]'),dialog=this.querySelector('dialog'),search=this.querySelector('[data-idn-search]');
   toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));menu.classList.toggle('is-open',open);});
   menu.addEventListener('click',event=>{if(event.target.closest('a')){menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');}});
   this.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.classList.contains('is-open')){menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');toggle.focus();}});
   search.addEventListener('click',()=>dialog.showModal());
   this.querySelector('[data-idn-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
   dialog.addEventListener('close',()=>search.focus());
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instinct-signature"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('instinct-signature'))customElements.define('instinct-signature',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const d=this.querySelector('dialog');let opener;this.querySelectorAll('[data-ids-project]').forEach(b=>b.addEventListener('click',()=>{opener=b;d.querySelector('.ids-dialog-media').replaceChildren(b.querySelector('img').cloneNode(true));d.querySelector('.ids-dialog-caption').textContent=b.closest('figure').querySelector('h3').textContent;d.showModal();}));d.querySelector('[data-ids-close]').addEventListener('click',()=>d.close());d.addEventListener('click',e=>{if(e.target===d)d.close();});d.addEventListener('close',()=>{d.querySelector('.ids-dialog-media').replaceChildren();opener?.focus();});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
